import type { InlineKeyboardMarkup, ChatMessage } from '../types/telegram';

interface InlineKeyboardProps {
  markup: InlineKeyboardMarkup;
  message: ChatMessage;
  onCallback: (data: string, message: ChatMessage) => void;
  disabled?: boolean;
}

export function InlineKeyboard({
  markup,
  message,
  onCallback,
  disabled = false,
}: InlineKeyboardProps): React.JSX.Element {
  return (
    <div className="mt-2 flex flex-col gap-1">
      {markup.inline_keyboard.map((row, rowIndex) => (
        <div key={rowIndex} className="flex gap-1">
          {row.map((button, buttonIndex) => {
            if (button.url !== undefined && button.url !== '') {
              return (
                <a
                  key={buttonIndex}
                  href={button.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex-1 rounded bg-telegram-blue/10 px-3 py-1.5 text-center text-sm text-telegram-blue hover:bg-telegram-blue/20 dark:bg-telegram-blue/20 dark:hover:bg-telegram-blue/30"
                >
                  {button.text} {'\u2197'}
                </a>
              );
            }

            const callbackData = button.callback_data;
            return (
              <button
                key={buttonIndex}
                onClick={() => {
                  if (callbackData !== undefined && callbackData !== '') {
                    onCallback(callbackData, message);
                  }
                }}
                disabled={disabled || callbackData === undefined || callbackData === ''}
                className="flex-1 rounded bg-telegram-blue/10 px-3 py-1.5 text-sm text-telegram-blue hover:bg-telegram-blue/20 disabled:opacity-50 dark:bg-telegram-blue/20 dark:hover:bg-telegram-blue/30"
              >
                {button.text}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
